<template>
  <div>
    <el-input
      type="textarea"
      autosize
      placeholder="Please input"
      :value="text"
      @input="$emit('input', $event)"
      @focus="$emit('on-textarea-edit', true)"
      @keydown.enter.native="enterEvent($event)"
    >
    </el-input>
    <span class="template-updated"><slot></slot></span>
  </div>
</template>
<script>
export default {
  name: "EditBoxTextarea",
  props: {
    textInput: String
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
    text: function() {
      return this.textInput;
    }
  },
  methods: {
    enterEvent(e) {
      if(!e.shiftKey) {
        e.preventDefault();
        e.target.blur();
        this.$emit('on-textarea-enter', true)
      }
    }
  }
};
</script>
<style scoped>
.template-updated {
  color: red;
}
</style>
